import styled from 'styled-components';
import { Layout } from 'antd';

export const LoginLayout = styled(Layout)`
  background-color: #fff;
`;
